/* eslint-disable no-restricted-syntax */
/* eslint-disable import/prefer-default-export */
import { MantineSize } from '@mantine/core';
import lodash from 'lodash';

type MantineSizeMap = {
  size: MantineSize;
  value: number;
};

type MantineSizeExtra = {
  current: MantineSize;
  smaller: MantineSize;
  bigger: MantineSize;
};

function calculateMantineSize(size: MantineSize): MantineSizeExtra {
  const mappings: MantineSizeMap[] = [
    { size: 'xs', value: 0 },
    { size: 'sm', value: 1 },
    { size: 'md', value: 2 },
    { size: 'lg', value: 3 },
    { size: 'xl', value: 4 },
  ];

  const currentSize = mappings.find((x) => x.size === size) || mappings[2];
  return {
    current: currentSize.size,
    smaller: mappings.find((x) => x.value === currentSize.value - 1)?.size || currentSize.size,
    bigger: mappings.find((x) => x.value === currentSize.value + 1)?.size || currentSize.size,
  };
}

export type ComboBoxDataV5 = {
  value: string;
  label: string;
  group: string;
  disabled?: boolean;
  [key: string]: any;
};
function transformComboBoxGroupDataFromV5toV7(
  data: ComboBoxDataV5[],
  includeSupplemental?: boolean
): {
  group: string;
  items: ({ value: string; label: string; disabled?: boolean } | string)[];
}[] {
  const finalData = [];
  const groupedData = lodash.groupBy(data, 'group');

  for (const key of Object.keys(groupedData)) {
    const items = groupedData[key];
    finalData.push({
      group: key,
      items: includeSupplemental
        ? items
        : items.map((x) => ({
            label: x.label,
            value: x.value,
            disabled: x.disabled,
          })),
    });
  }
  return finalData;
}

export { calculateMantineSize, transformComboBoxGroupDataFromV5toV7 };
